// #region imports

import * as React from 'react';

// Material-UI
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField'

// #endregion

// #region interfaces

interface GuestGenderSelectProps {
  gender: string;
  genderSelected: (gender: string) => void;
}

// #endregion

const GuestGenderSelect: React.FC<GuestGenderSelectProps> = (props) => {

  // #region Styles

  const styles = {
    selectWidth: {
      flexGrow: 1,
      minWidth: 120,
    },
  };

  // #endregion

  // #region Event handlers

  const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.genderSelected(event.target.value);
  };

  // #endregion

  return (
    <TextField
      sx={styles.selectWidth}
      label='Gender'
      onChange={handleGenderChange}
      select
      value={props.gender}
    >
      <MenuItem key={-1} value={-1}>Select guest gender</MenuItem>
      <MenuItem key={'f'} value={'F'}>Female</MenuItem>
      <MenuItem key={'m'} value={'M'}>Male</MenuItem>
      <MenuItem key={'n'} value={'N'}>NonBinary</MenuItem>
    </TextField>
  );

}

export default GuestGenderSelect;